if (!customElements.get('flavour-drawer')) {
  customElements.define(
    'flavour-drawer',
    class FlavourDrawer extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.flavour-drawer__trigger');
        this.panel = this.querySelector('.flavour-drawer__panel');
        this.overlay = this.querySelector('.flavour-drawer__overlay');
        this.closeButton = this.panel?.querySelector('.flavour-drawer__close');
        this.rows = [...(this.panel?.querySelectorAll('.flavour-drawer__row, .flavour-drawer__tile') || [])];

        if (!this.trigger || !this.panel || !this.overlay) return;

        this.abort = new AbortController();
        const { signal } = this.abort;

        document.body.append(this.overlay, this.panel);

        this.trigger.addEventListener('click', () => this.open(), { signal });
        this.closeButton?.addEventListener('click', () => this.close(), { signal });
        this.overlay.addEventListener('click', () => this.close(), { signal });
        this.panel.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        this.rows.forEach((row, index) => {
          row.addEventListener('click', (event) => this.onRowClick(event, row), { signal });
          row.addEventListener('keydown', (event) => this.onRowKeydown(event, index), { signal });
        });
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.overlay?.remove();
        this.panel?.remove();
        document.body.classList.remove('flavour-drawer-open');
      }

      onRowClick(event, row) {
        if (row.dataset.current === 'true') {
          event.preventDefault();
          this.close();
        }
      }

      onRowKeydown(event, index) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        const next = this.rows[index + (event.key === 'ArrowDown' ? 1 : -1)];
        next?.focus();
      }

      focusable() {
        return [...this.panel.querySelectorAll('a[href], button:not([disabled])')];
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const items = this.focusable();
        if (items.length === 0) return;
        const first = items[0];
        const last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      open() {
        this.overlay.classList.add('is-open');
        this.panel.classList.add('is-open');
        this.panel.setAttribute('aria-hidden', 'false');
        this.panel.removeAttribute('inert');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('flavour-drawer-open');
        const current = this.rows.find((row) => row.dataset.current === 'true');
        (current || this.closeButton)?.focus();
      }

      close() {
        this.overlay.classList.remove('is-open');
        this.panel.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
        this.panel.setAttribute('inert', '');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('flavour-drawer-open');
        this.trigger.focus();
      }
    }
  );
}
